import Text, { TextType } from "components/Text";
import { responsiveStylingMax } from "lib/responsive";
import { BrandColorPalette, TextAndShapesPalette } from "lib/styles/colors";
import { ReactElement } from "react";
import styled from "styled-components";
import { NewsSearchRow } from "./NewsSearchRow";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  width: 100%;
  max-width: 820px;
  ${responsiveStylingMax({
    "<1024": `
    max-width: 100%;
    `,
  })};
`;

const Spacer = styled.div`
  height: 4px;
  margin: 40px 0px;
  width: 100%;
  background: ${BrandColorPalette.BASIC_DECORATION_BLUE};
`;

export function NewsFeedHeader(): ReactElement {
  return (
    <Container>
      <Text
        type={TextType.HEADING_MEDIUM}
        fontColor={TextAndShapesPalette.BRAND_BLACK}
      >
        Maritime News
      </Text>
      <Text
        type={TextType.HEADING_SMALL}
        fontColor={TextAndShapesPalette.BRAND_BLACK}
        style={{
          marginBottom: "24px",
          marginTop: "8px",
          padding: "0px 16px",
          textAlign: "center",
        }}
      >
        Get informed on the latest maritime news.
      </Text>
      <NewsSearchRow />
      <Spacer />
    </Container>
  );
}
